import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a433bd76"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tabs-home is-fullwidth" }
const _hoisted_2 = { class: "text" }
const _hoisted_3 = { class: "arrow" }
const _hoisted_4 = { class: "text" }
const _hoisted_5 = { class: "arrow" }
const _hoisted_6 = { class: "activity-wrapper" }
const _hoisted_7 = { class: "text" }
const _hoisted_8 = {
  key: 0,
  class: "tag is-rounded activity-tag",
  "data-testid": "activity-counter"
}
const _hoisted_9 = { class: "arrow" }

import { useAppStore } from '@/popup/store/AppStore'
import { useUIStore } from '@/popup/store/UIStore'
import { Tab } from '@/shared/models/Profile'
import SvgIcon from '@/popup/components/shared/SvgIcon.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Tabs',
  setup(__props) {

const appStore = useAppStore()
const uiStore = useUIStore()

const clickTab = (currentTab: Tab) => {
  const tabToSwitch = uiStore.currentTab === currentTab ? undefined : currentTab
  uiStore.setCurrentTab(tabToSwitch, { path: '/home' })
}

const activityCounter = () => {
  const counter = appStore.pendingApprovalsCount

  if (counter > 9) {
    return '9+'
  }

  return counter
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass({ active: _unref(uiStore).currentTab === _unref(Tab).AUTHENTICATED }),
      "data-testid": "tab-authenticated"
    }, [
      _createElementVNode("a", {
        "data-testid": "link-authenticated",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (clickTab(_unref(Tab).AUTHENTICATED)))
      }, [
        _createVNode(SvgIcon, {
          name: "connections",
          color: "var(--neutral-70)",
          height: "16",
          width: "16"
        }),
        _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t('profile.tabs.connections')), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_unref(uiStore).currentTab === _unref(Tab).AUTHENTICATED)
          ? (_openBlock(), _createBlock(SvgIcon, {
              key: 0,
              name: "arrow-up-divider",
              color: "var(--neutral-20)",
              class: "arrow-up",
              height: "16",
              width: "16"
            }))
          : _createCommentVNode("v-if", true)
      ])
    ], 2 /* CLASS */),
    _createElementVNode("div", {
      class: _normalizeClass({ active: _unref(uiStore).currentTab === _unref(Tab).AUTHORIZED }),
      "data-testid": "tab-authorized"
    }, [
      _createElementVNode("a", {
        class: "authorized-tab",
        "data-testid": "link-authorized",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (clickTab(_unref(Tab).AUTHORIZED)))
      }, [
        _createVNode(SvgIcon, {
          name: "controllers",
          color: "var(--neutral-70)",
          height: "16",
          width: "16"
        }),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.$t('profile.tabs.controllers')), 1 /* TEXT */)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_unref(uiStore).currentTab === _unref(Tab).AUTHORIZED)
          ? (_openBlock(), _createBlock(SvgIcon, {
              key: 0,
              name: "arrow-up-divider",
              color: "var(--neutral-20)",
              class: "arrow-up",
              height: "16",
              width: "16"
            }))
          : _createCommentVNode("v-if", true)
      ])
    ], 2 /* CLASS */),
    _createElementVNode("div", {
      class: _normalizeClass({ active: _unref(uiStore).currentTab === _unref(Tab).ACTIVITY }),
      "data-testid": "tab-activity"
    }, [
      _createElementVNode("a", {
        class: "",
        "data-testid": "link-activity",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (clickTab(_unref(Tab).ACTIVITY)))
      }, [
        _createVNode(SvgIcon, {
          name: "menu",
          color: "var(--neutral-70)",
          height: "16",
          width: "16"
        }),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.$t('profile.tabs.activity')), 1 /* TEXT */),
          (_unref(appStore).pendingApprovalsCount > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(activityCounter()), 1 /* TEXT */))
            : _createCommentVNode("v-if", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        (_unref(uiStore).currentTab === _unref(Tab).ACTIVITY)
          ? (_openBlock(), _createBlock(SvgIcon, {
              key: 0,
              name: "arrow-up-divider",
              color: "var(--neutral-20)",
              class: "arrow-up",
              height: "16",
              width: "16"
            }))
          : _createCommentVNode("v-if", true)
      ])
    ], 2 /* CLASS */)
  ]))
}
}

})